





















































import { Component, Vue, Emit, Prop } from "vue-property-decorator";

@Component
export default class SpecialSignUp extends Vue {
    @Prop() email!: string;
    valid: boolean = false;

    public get signupData(): {
        key: { id: string; value: string | boolean };
        label: string;
        rule: string[];
        type: string;
    }[] {
        return [
            {
                key: { id: "email", value: this.email },
                label: "studio.specialSignUp.email",
                rule: ["required", "email"],
                type: "textbox",
            },
            {
                key: { id: "name", value: "" },
                label: "studio.specialSignUp.name",
                rule: ["required", "length"],
                type: "textbox",
            },
            {
                key: { id: "surname", value: "" },
                label: "studio.specialSignUp.surName",
                rule: ["required", "length"],
                type: "textbox",
            },
            {
                key: { id: "zip", value: "" },
                label: "studio.specialSignUp.zip",
                rule: ["required", "length"],
                type: "textbox",
            },
            {
                key: { id: "company", value: "" },
                label: "studio.specialSignUp.company",
                rule: ["required", "length"],
                type: "textbox",
            },
            {
                key: { id: "disclaimer", value: false },
                label: "studio.specialSignUp.disclaimer",
                rule: ["required"],
                type: "checkbox",
            },
            {
                key: { id: "subscriber", value: false },
                label: "studio.specialSignUp.subscriber",
                rule: [],
                type: "checkbox",
            },
        ];
    }

    public get rules(): { [key: string]: (v: string) => boolean | string } {
        return {
            required: v => !!v || (this.$t("studio.required") as string),
            length: v =>
                v.length < 255 || (this.$t("guest.username.invalid") as string),
            email: v =>
                /^$|^[\w.-]+@[\w.-]+$/gi.test(v) ||
                (this.$t("guest.email.invalid") as string),
        };
    }

    @Emit() submit() {
        const result: {
            [key: string]: string | boolean;
        } = {};
        this.signupData.forEach(e => (result[e.key.id] = e.key.value));
        result["registDateTime"] = new Date().toISOString();
        return result;
    }
}
